import React, { useEffect } from "react";
import { getAPIUrlBM } from "../../../utils/config";
import backlinkPost from "../../../Apis/backlink/Post";
// import axios from "axios";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import backLinkgetCall from "../../../Apis/backlink/Get";

const FindBacklinks = ({ handleClose, domain }) => {
  const [isBlock, setIsBlock] = useState(false);
  // const [mojData, setMojData] = useState([]);
  const [domainForMoz, setDomainForMoz] = useState("");
  // const [count, setCount] = useState(0);
  window.nextpointer = null;
  window.sendRequest = false;
  const [allDomainName, setAllDomainName] = useState([]);
  const [selectedApi, setSelectedApi] = useState("moz");
  const [fetchWeekly, setFetchWeekly] = useState(false);
  const [mode, setMode] = useState("host");
  const { currentWorkSpaceAddOns } = useSelector((state) => state.userData);
  const linkAssistantAddon = currentWorkSpaceAddOns?.find(
    (addOn) => addOn.name === "linkAssistant",
  );
  const getAllDomainName = async () => {
    try {
      const url = getAPIUrlBM();
      const response = await backlinkPost(url + "/getDomainName");
      console.log(response);
      if (Array.isArray(response.data)) {
        const data = response.data.map((item) => {
          // return item.domain;
          return item.domain
            .replace("http://", "")
            .replace("https://", "")
            .replace("www.", "");
        });
        setAllDomainName(data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const url = getAPIUrlBM();
        const response = await backLinkgetCall(
          url + "/getDiscoverLinksSettings",
        );
        console.log({ settingFetch: response });
        if (response?.data?.fetch_weekly) {
          setFetchWeekly(response?.data?.fetch_weekly === 1 ? true : false);
        }
        if (response?.data?.operation_mode) {
          setMode(response?.data?.operation_mode);
        }
      } catch (error) {
        console.log(error);
      }
    };
    if (domain) {
      const domainEle = document.getElementById("domainInput");
      setDomainForMoz(domain);
      domainEle.value = domain;
      domainEle.disabled = true;
    } else {
      getAllDomainName();
    }
    fetchSettings();
  }, []);

  const navigate = useNavigate();
  const handleOnclick = async () => {
    try {
      const domainEle = document.getElementById("domainInput").value;
      let selectedDomain = document.getElementsByName("curListInFetch")[0];

      selectedDomain = selectedDomain?.value;

      if (!domain) {
        if (!domainEle || domainEle.length === 0) {
          return window.sweet({
            text: "Please enter a domain",
            icon: "error",
            buttons: false,
          });
        }
        if (selectedDomain === "Select a domain") {
          return window.sweet({
            text: "Please select a domain",
            icon: "error",
            buttons: false,
          });
        }
        if (
          domainEle
            .replace("http://", "")
            .replace("https://", "")
            .replace("www.", "")
            .split("/")[0] !== selectedDomain
        ) {
          return window.sweet({
            text: "Please add this domain",
            icon: "error",
            buttons: false,
          });
        }
      }
      const url = getAPIUrlBM();
      const radioButtons = document.querySelectorAll(
        'input[name="domainOrLink"]',
      );
      const typeOfBacklink = document.querySelectorAll(
        'input[name="typeOfBacklinks"]',
      );

      const api = document.querySelectorAll('input[name="api"]');

      let selectedValue, typeOfBacklinkValue, apiValue;

      for (let i = 0; i < radioButtons.length; i++) {
        if (radioButtons[i].checked) {
          selectedValue = radioButtons[i].value;
          break;
        }
      }
      for (let i = 0; i < typeOfBacklink.length; i++) {
        if (typeOfBacklink[i].checked) {
          typeOfBacklinkValue = typeOfBacklink[i].value;
          break;
        }
      }

      for (let i = 0; i < api.length; i++) {
        if (api[i].checked) {
          apiValue = api[i].value;
          break;
        }
      }

      console.log({ apiValue });

      if (!selectedValue) {
        // mark the border red which has name 'domainOrLink'
        return window.sweet({
          text: "Please fill the form correctly",
          icon: "error",
          buttons: false,
        });
      }
      if (!typeOfBacklinkValue) {
        document.getElementsByName("typeOfBacklinks")[0].style.border =
          "1px solid red";
        return window.sweet({
          text: "Please select a type of backlink",
          icon: "error",
          buttons: false,
        });
      }
      const response = await backlinkPost(url + "/get/backlinks", {
        url: domain || domainEle,
        type: selectedValue,
        backlinkType: typeOfBacklinkValue,
      });
      if (!domain) {
        handleClose();
        // how to open a new tab
        // return window.open("/backlink/fetch-backlinks", "_blank");
        return navigate("/backlink/fetch-backlinks", {
          state: {
            domain: domainEle,
            type: selectedValue,
            api: apiValue,
            backlinkType: typeOfBacklinkValue,
          },
        });
      }
      return navigate("/backlink/fetch-backlinks", {
        state: {
          domain: domain || domainEle,
          type: selectedValue,
          backlinkType: typeOfBacklinkValue,
          api: apiValue,
        },
      });
      // setIsBlock(true);
      // await callMoz(domainEle);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSettings = async () => {
    try {
      const url = getAPIUrlBM();

      const domainEle = document.getElementById("domainInput").value;
      let selectedDomain = document.getElementsByName("curListInFetch")[0];

      selectedDomain = selectedDomain?.value;

      if (!domain) {
        if (!domainEle || domainEle.length === 0) {
          return window.sweet({
            text: "Please enter a domain",
            icon: "error",
            buttons: false,
          });
        }
        if (selectedDomain === "Select a domain") {
          return window.sweet({
            text: "Please select a domain",
            icon: "error",
            buttons: false,
          });
        }
        if (
          domainEle
            .replace("http://", "")
            .replace("https://", "")
            .replace("www.", "")
            .split("/")[0] !== selectedDomain
        ) {
          return window.sweet({
            text: "Please add this domain",
            icon: "error",
            buttons: false,
          });
        }
      }

      const response = await backlinkPost(url + "/saveDiscoverLinksSettings", {
        fetchWeekly,
        mode,
        url: domain || domainEle,
      });
      console.log({ settingFetch: response });
      if (response?.message === "Settings saved successfully") {
        window.sweet({
          text: "Settings saved successfully",
          icon: "success",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="popup-box">
      <div
        id="inside_div"
        style={{
          width: "40%",
          // height: "max-content",

          // marginLeft: "35%",
        }}
        className="boxx"
      >
        <div
          className="container d-flex flex-row justify-content-between position-sticky fixed-top"
          style={{ backgroundColor: "#363740", fontSize: "x-large" }}
        >
          <div className="text-light my-3">
            Get backlinks {domain ? `for  ${domain}  ` : ""}
          </div>
          <span
            onClick={handleClose}
            className="text-muted px-2 "
            style={{ fontSize: "xxx-large" }}
          >
            x
          </span>
        </div>

        <div className="boxx-down">
          <div
            className="container"
            style={{
              paddingTop: "2rem",
              paddingBottom: "2rem",
            }}
          >
            <div
              className="px-5 mb-3"
              style={{
                display: domain ? "none" : "",
              }}
            >
              <div className="filterItem1">
                <p className="subHeader titleInFindBacklinks">
                  {" "}
                  Select a Domain
                </p>
                <select
                  name="curListInFetch"
                  style={{
                    width: "100%",
                    borderColor: "#ced4da",
                  }}
                >
                  <option value={undefined}>Select a domain</option>
                  {allDomainName?.map((name, index) => (
                    <option value={name} key={index}>
                      {name}
                    </option>
                  ))}
                </select>

                <Link
                  style={{
                    textDecoration: "none",
                    fontWeight: "700",
                  }}
                  to="/backlink/domain"
                >
                  Add New Domain
                </Link>
              </div>
            </div>
            <div className="px-5 mb-3">
              <div className="titleInFindBacklinks">
                Domain, sub-domain or URL{" "}
              </div>
              {domain ? (
                <input
                  style={{ borderRadius: "9px" }}
                  type="text"
                  defaultValue={domain}
                  className="form-control inputInFindBacklinks"
                  id="domainInput"
                  placeholder="https://docs.google.com/document/d/......"
                />
              ) : allDomainName.length ? (
                <input
                  style={{ borderRadius: "9px" }}
                  type="text"
                  className="form-control inputInFindBacklinks"
                  id="domainInput"
                  placeholder="https://docs.google.com/document/d/......"
                />
              ) : (
                <input
                  style={{ borderRadius: "9px" }}
                  type="text"
                  className="form-control inputInFindBacklinks"
                  disabled
                  id="domainInput"
                  placeholder="No domain found, please add the domain"
                />
              )}
            </div>
            <div className="px-5 mb-3">
              <div className="  form-group ">
                <div className="titleInFindBacklinks">Find backlinks for</div>
                <div
                  style={{
                    padding: "0 2rem",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <label className="" htmlFor="exampleFormControlInput1">
                      Domains
                    </label>
                    <input
                      defaultChecked
                      type="radio"
                      name="domainOrLink"
                      value="domains"
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <label className="" htmlFor="exampleFormControlInput1">
                      Domains & sub-domains
                    </label>
                    <input
                      type="radio"
                      name="domainOrLink"
                      value="domainsAndSubdomains"
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <label className="" htmlFor="exampleFormControlInput1">
                      Given URL only
                    </label>
                    <input type="radio" name="domainOrLink" value="url" />
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="px-5 mb-3 d-flex gap-5 ">
              <div style={{ flex: 1 }}>
                <label className="titleInFindBacklinks">
                  Min Domain Rating
                </label>
                <input
                  type="number"
                  placeholder="Min"
                  className="form-control inputInFindBacklinks m-0"
                />
              </div>
              <div style={{ flex: 1 }}>
                <label className="titleInFindBacklinks">
                  Max Domain Rating
                </label>
                <input
                  type="number"
                  placeholder="Max"
                  className="form-control inputInFindBacklinks m-0"
                />
              </div>
            </div> */}

            <div className="px-5 mb-3">
              <div className="  form-group ">
                <div className="titleInFindBacklinks">Type of backlinks</div>
                <div
                  style={{
                    padding: "0 2rem",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <label className="" htmlFor="AllLinks">
                      All links
                    </label>
                    <input
                      type="radio"
                      name="typeOfBacklinks"
                      value="external"
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <label className="" htmlFor="DofollowLinksOnly">
                      Dofollow links only
                    </label>
                    <input
                      type="radio"
                      defaultChecked
                      name="typeOfBacklinks"
                      value="follow"
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <label className="" htmlFor="exampleFormControlInput1">
                      Nofollow links only
                    </label>
                    <input
                      type="radio"
                      name="typeOfBacklinks"
                      value="nofollow"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="px-5 mb-3">
              <div className="  form-group ">
                <div className="titleInFindBacklinks">
                  API to discover Backlinks
                </div>
                <div
                  style={{
                    padding: "0 2rem",
                  }}
                >
                  {!linkAssistantAddon && (
                    <p
                      style={{
                        fontSize: "14px",
                        marginBottom: 2,
                        color: "red",
                      }}
                    >
                      Please purchase the addon to use link Assistant API here -
                      https://buy.stripe.com/8wM7vIbH43gIaCk6pk You get 20,000
                      backlink credits for $19 per month.
                    </p>
                  )}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <label className="" htmlFor="linkAssistantApi">
                      Link Assistant API
                    </label>
                    <input
                      type="radio"
                      name="api"
                      value="linkAssistant"
                      checked={selectedApi === "linkAssistant"}
                      disabled={!linkAssistantAddon}
                      onChange={(e) => setSelectedApi(e.target.value)}
                    />
                  </div>
                  {selectedApi === "linkAssistant" && (
                    <div>
                      <hr />
                      <p style={{ textAlign: "center", marginBottom: 20 }}>
                        Settings For link Assistant
                      </p>
                      <p className="subDescription">
                        Configure the settings so that we can continously
                        monitor and discover backlinks for you links
                      </p>

                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                        }}
                      >
                        <label>Discover Backlinks weekly</label>
                        <input
                          type="checkbox"
                          name="discoverBacklinksWeekly"
                          checked={fetchWeekly}
                          onChange={(e) => setFetchWeekly(e.target.checked)}
                        />
                      </div>
                      {fetchWeekly && (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                            marginBottom: 10,
                          }}
                        >
                          <label>Mode</label>
                          <select
                            name="mode"
                            value={mode}
                            onChange={(e) => setMode(e.target.value)}
                          >
                            <option value="host">Domains</option>
                            <option value="domain">
                              Domains & Sub domains
                            </option>
                            <option value="url">Given URL only</option>
                          </select>
                        </div>
                      )}
                      <button
                        type="button"
                        className=" mt-3 mx-3 rounded-lg btn btn-primary "
                        style={{
                          backgroundColor: "#4b2ca9",
                          fontWeight: "500",
                          height: " 3rem",
                          width: "-webkit-fill-available",
                          fontSize: "larger",
                        }}
                        onClick={handleSettings}
                      >
                        Save
                      </button>
                      <hr />
                    </div>
                  )}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <label className="" htmlFor="MozApi">
                      MOZ API
                    </label>
                    <input
                      type="radio"
                      // defaultChecked
                      checked={selectedApi === "moz"}
                      name="api"
                      value="moz"
                      onChange={(e) => setSelectedApi(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="px-5 ">
              <div className="  form-group ">
                <div className="titleInFindBacklinks">Type of backlinks</div>
                <div
                  style={{
                    padding: "0 2rem",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <label className="" htmlFor="exampleFormControlInput1">
                      All backlinks
                    </label>
                    <input
                      type="radio"
                      name="typeOfBacklink"
                      value="allBacklink"
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <label className="" htmlFor="exampleFormControlInput1">
                      New backlinks
                    </label>
                    <input
                      type="radio"
                      name="typeOfBacklink"
                      value="newBacklink"
                    />
                  </div>
                </div>
              </div>
            </div> */}
            <div className="px-5">
              <button
                type="button"
                className=" mt-3 mx-3 rounded-lg btn btn-primary "
                style={{
                  backgroundColor: "#4b2ca9",
                  fontWeight: "500",
                  height: " 3rem",
                  width: "-webkit-fill-available",
                  fontSize: "larger",
                }}
                onClick={handleOnclick}
                disabled={isBlock}
              >
                Get Backlinks
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FindBacklinks;
